/// <reference path="../app.js"/>

class ContactFormBehaviour {
	static setupForm() {
		$(".ContactElement .open-form").on("click", function() {
			$(`#contact-form-${$(this).parent().data("id")} .send-to-field`).val($(this).data("email"));
			$(this).parent().parent().addClass("show-form");
			$(this).parent().parent().find(".topic-dropdown").val($(this).data("id"));
		});
	}

	static setupEventListeners() {
		$(".ContactElement form").on("submit", function(event) {
			let self = $(this);

			function showMessage(text) {
				$(`#contact-message-reveal-${self.parent().data("id")} .message`).text(text);
				self.parent().find(".open-reveal").trigger("click");

				// @ts-ignore
				grecaptcha.reset();
			}

			let params = {};
			
			$(this).find("fieldset input:not([type=submit]), fieldset select").each((index, element) => {
				let self = $(element);
				params[self.attr("name")] = self.val();
				self.val("");
			});

			$.get(
				"/forms/submitContactForm",
				params
			).fail(() => {
				showMessage("We are unable to handle this request at the moment, please try again later.");
			}).done(res => {
				try {
					showMessage(JSON.parse(res).message);
				}
				catch (err) {
					showMessage("We are unable to handle this request at the moment, please try again later.");
					console.log("Contact form submission error\n", err, "\n", res);
				}
			});

			event.preventDefault();		
		});

		$(".contact-form .close-form").on("click", function() {
			$(this).parents().find(".ContactElement").first().removeClass("show-form");
		});
	}

	static init() {
		this.setupForm();
		this.setupEventListeners();
	}
}